import { render, staticRenderFns } from "./Perintah.vue?vue&type=template&id=6d663d2e&"
import script from "./Perintah.vue?vue&type=script&lang=js&"
export * from "./Perintah.vue?vue&type=script&lang=js&"
import style0 from "./Perintah.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports